"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Parser_1 = require("../Parser");
var product_1 = require("../../utils/shopify/product");
var color_1 = require("../common/color");
var react_1 = require("swiper/react");
var SwiperNavArrows_1 = require("../../Swiper/SwiperNavArrows");
var modules_1 = require("swiper/modules");
var MultiProductCarouselUro = function (props) {
    var modules = [modules_1.Navigation];
    modules.push(modules_1.Pagination);
    return ((0, preact_1.h)("div", { className: "multi-product-carousel-uro" },
        (0, preact_1.h)(react_1.Swiper, { pagination: { clickable: true }, slidesPerView: 1.2, resizeObserver: true, loop: true, centeredSlides: true, centerInsufficientSlides: true, watchOverflow: true, spaceBetween: 15, breakpoints: {
                1025: {
                    slidesPerView: 3,
                },
            } },
            (0, preact_1.h)(SwiperNavArrows_1.default, null),
            props.prodList.map(function (product, index) {
                var _a, _b, _c, _d;
                //grab first product variant
                var variant = product.variants.nodes.at(0);
                var targetUrl = "https://opositiv.com/products/".concat(product.handle);
                return ((0, preact_1.h)(react_1.SwiperSlide, { key: index },
                    (0, preact_1.h)("div", { class: "multi-product-carousel-uro__card" },
                        (0, preact_1.h)("div", { class: "multi-product-carousel-uro__card-img-container" },
                            (0, preact_1.h)("img", { class: "multi-product-carousel-uro__card-prod-img", src: (_a = product.featuredImage) === null || _a === void 0 ? void 0 : _a.url, alt: "product image" }),
                            (0, preact_1.h)("img", { class: "multi-product-carousel-uro__card-gradient", src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/product-card-bg.png?v=1713225715", alt: "card bg" })),
                        (0, preact_1.h)("h3", { class: "multi-product-carousel-uro__card-title", style: { color: product.color && (0, color_1.toHex)(product.color) } }, (_b = product.header1) === null || _b === void 0 ? void 0 :
                            _b.value,
                            (0, preact_1.h)("br", null),
                            (0, preact_1.h)("span", { class: "multi-product-carousel-uro__card-subtitle", style: { color: product.color && (0, color_1.toHex)(product.color) } }, (_c = product.header2) === null || _c === void 0 ? void 0 : _c.value)),
                        (0, preact_1.h)("span", { class: 'multi-product-carousel-uro__card-claims-title' }, product.claimsDescription && (0, Parser_1.parse)(product.claimsDescription)),
                        (0, preact_1.h)("div", { class: 'multi-product-carousel-uro__card-claims-list' }, (_d = product.claims) === null || _d === void 0 ? void 0 : _d.map(function (claim) {
                            return ((0, preact_1.h)("div", { class: "multi-product-carousel-uro__card-claim" },
                                (0, preact_1.h)("img", { class: "multi-product-carousel-uro__card-claim-icon", src: claim.iconUrl, alt: "claim icon" }),
                                (0, preact_1.h)("p", { class: "multi-product-carousel-uro__card-claim-text" },
                                    ' ',
                                    (0, Parser_1.parse)(claim.claimText))));
                        })),
                        (0, preact_1.h)("a", { class: "multi-product-carousel-uro__card-addBtn", style: { background: product.color && (0, color_1.toHex)(product.color) }, href: targetUrl }, "Learn More"),
                        variant && ((0, preact_1.h)("a", { class: "multi-product-carousel-uro__card-explore", onClick: function () {
                                (0, product_1.addToCart)(variant);
                            } },
                            ' ',
                            "Quick Add",
                            ' ')))));
            }))));
};
exports.default = MultiProductCarouselUro;
